import React from 'react';

const Radio = (props) => {
    const {
        name        = '',
        value       = '',
        onChange    = (value) => {},
        disabled    = false,
        options     = [{
            value:  '',
            label:  ''
        }],
        style       = null
    } = props;

    const renderRadioButton = (option) => {
        const id = name+'_'+option.value;

        return (
            <div className={'radio-outer'} key={option.value}>
                <input type="radio"
                       value={option.value}
                       name={name}
                       id={id}
                       checked={option.value === value}
                       disabled={disabled}
                       onChange={() => onChange(option.value)}
                />
                <label htmlFor={id}>
                    <span>{option.label}</span>
                </label>
            </div>
        )
    }

    return (
        <div className={'form-input-radio-container'}>
            <fieldset id={'name'} style={style}>
                {!!options && options.length > 0 && options.map((option, index) => {
                    return renderRadioButton(option);
                })}
            </fieldset>
        </div>
    )
}

export default Radio;
